import store from '@/store'

export const db = {
  async getDb (appointmentId) {
    return new Promise((resolve, reject) => {
      let request = window.indexedDB.open(`video_openhealthcare_db_${appointmentId}`, '1.0')
      request.onerror = e => {
        console.log('Error opening db', e)
        reject(e)
      }
      request.onsuccess = e => {
        resolve(e.target.result)
      }
      request.onupgradeneeded = e => {
        console.log('onupgradeneeded')
        let db = e.target.result
        db.createObjectStore('messages', { autoIncrement: true, keyPath: 'id' })
      }
    })
  },
  async addMessageToDb (message, fileUrl) {
    return new Promise((resolve, reject) => {
      let trans = store.state.video.db.transaction(['messages'], 'readwrite')
      trans.onsuccess = async e => {
        resolve(e)
      }
      let objStore = trans.objectStore('messages')
      objStore.add(message)
    })
  },
  async getMessagesFromDb (appointmentId) {
    return new Promise((resolve, reject) => {
      let trans = store.state.video.db.transaction(['messages'], 'readonly')
      trans.oncomplete = e => {
        resolve(messages)
      }
      let objStore = trans.objectStore('messages')
      let messages = []
      objStore.openCursor().onsuccess = async e => {
        let cursor = e.target.result
        if (cursor) {
          messages.push(cursor.value)
          cursor.continue()
        }
      }
    })
  },
  async deleteMessagesFromDb () {
    return new Promise((resolve, reject) => {
      let trans = store.state.db.transaction(['messages'], 'readwrite')
      trans.oncomplete = e => {
        resolve()
      }
      let objStore = trans.objectStore('messages')
      objStore.clear()
    })
  }
}



// WEBPACK FOOTER //
// ./src/indexedDB.js